<template>
  <div class="ouija">
    <p>
      Vous vous asseyez et posez tous les deux votre doigt sur la goutte reposant sur le
      Ouija. Vous fermez les yeux et un silence de mort s'abat dans la pièce. Carmen entame la
      séance : « Esprit, es-tu là ? ». Vous frissonnez intérieurement. Vous êtes pourtant presque
      habitué aux déplacement surnaturels de l'objet pointu sur le bois de la planche
      parfaitement lisse. Mais cette fois, à votre grande surprise, celui-ci ne bouge pas d'un iota.
    </p>
    <p>
      Inquiet vous rouvrez les yeux et constatez que Carmen semble confuse. Les esprits
      auraient-ils du mal à entrer en communication avec vous ? Était-ce de votre faute ? Mais
      vos doutes sont de courte durée : toutes les bougies s' éteignent simultanément, plongeant
      le logis de votre hôte dans le noir !
    </p>
    <p>
      Une chaise racle le parquet, votre voisine rallume les lumières, et elle éclate de rire
      lorsqu’elle revient s’asseoir à table : certaines lettres ont pris différentes teintes colorées !
    </p>
    <div class="img-container">
      <img src="../../assets/Gipsy/colored_ouija.png" alt />
    </div>
    <p>
      « Pas besoin de la goutte ce soir, s'exclame Carmen, on dirait qu'après la pluie vient
      le beau temps ». Vous déchiffrez ses paroles, prononcez le mot obtenu à haute voix, et un
      mystérieux livre, curieusement daté du siècle prochain, apparaît clairement dans votre
      esprit. Bien que surpris, sa couverture ne fait pas l'ombre d'un doute sur le message que
      l'on veut vous livrer ce soir ! La séance peut prendre fin.
    </p>
    <div class="hints">
      <div v-for="(hint, index) in reduceList" :key="index">
        <button
          :class="getClass(hint, index)"
          @click="display(hint.id)"
          :disabled="getClass(hint, index) === 'inactive' "
        >🕯 #{{index + 1}}</button>
      </div>
    </div>
    <div v-for="(hint, index) in reduceList" :key="index">
      <hint
        v-if="hint.display"
        :content="hint.content"
        :index="index"
        :read="hint.read"
        @close="closeHints()"
        @continue="increment(hint.id)"
      />
    </div>
  </div>
</template>
<script>
import Hint from "../Gipsy/Hint";

export default {
  name: "Ouija",
  props: {
    hintList: Array
  },
  components: {
    Hint
  },
  data() {
    return {
      hints: this.hintList,
      reduceList: this.hintList.filter(h => h.vue === "dayThree")
    };
  },
  methods: {
    closeHints() {
      this.hints.forEach(h => {
        h.display = false;
      });
    },
    display(id) {
      this.closeHints();
      this.hints.find(h => h.id === id).display = true;
    },
    getClass(hint, index) {
      if (this.hints.find(h => h.id === hint.id).read) return "read";
      if (index === 0) return "active";
      if (this.reduceList[index - 1].read) return "active";
      return "inactive";
    },
    increment(id) {
      this.hints.find(h => h.id === id).read = true;
      this.$emit("updateHints", this.hints);
      this.$emit("incrementCounter");
    }
  }
};
</script>

<style scoped>
p {
  font-family: "Libre Caslon Text", serif;
  font-size: 15px;
}
.ouija {
  padding: 5% 10%;
  font-size: 20px;
  overflow: scroll;
  text-align: justify;
  height: 90%;
}
.img-container {
  text-align: center;
}
.ouija img {
  width: 80%;
}
.hints {
  margin-bottom: 3%;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}
.hints button {
  font-family: "IBM Plex Mono", monospace;
  font-weight: bold;
  border: none;
  border-radius: 3px;
}
.hints button:focus {
  outline: none;
}
.inactive {
  cursor: not-allowed;
  background: #ce322c;
  color: rgb(235, 235, 235);
}
.active {
  cursor: pointer;
  background: #faa806;
  color: rgb(235, 235, 235);
}
.read {
  cursor: pointer;
  background: #01593b;
  color: rgb(235, 235, 235);
}
</style>